function getElementMarkers() {
    const startMarkerParent = document.querySelector('[data-color-scroller="start"]').parentNode;
    const endMarkerParent = document.querySelector('[data-color-scroller="end"]').parentNode;

    const elementsBetween = [];
    let collectElements = false;

    const mainElements = document.querySelector('main').children;

    for (let i = 0; i < mainElements.length; i++) {
        const element = mainElements[i];

        if (element.id === startMarkerParent.id) {
            collectElements = true;
            continue;
        }

        if (element.id === endMarkerParent.id) {
            collectElements = false; // Stop collecting elements when we reach the end marker
            break;
        }

        if (collectElements) {
            elementsBetween.push(element);
        }
    }

    const colorsArray = {
        turquoise: '#00c4b3',
        green: '#C5E86C',
    };

    // Add the element to the DOM.
    const containerDiv = document.createElement('div');
    containerDiv.classList.add('color-scroller');
    containerDiv.setAttribute('id', 'js-color-scroller');
    const parentElement = elementsBetween[0].parentElement;
    parentElement.insertBefore(containerDiv, elementsBetween[0].nextSibling);

    // Add the data-bg attribute and insert the section into the container.
    convertDom(containerDiv, elementsBetween, colorsArray);

    // Set scroll event listener
    colorScroller(containerDiv);
}

function convertDom(containerDiv, elementsBetween, colorsArray) {
    for (let i = 0; i < elementsBetween.length; i++) {
        const element = elementsBetween[i];
        const colorKeys = Object.keys(colorsArray);

        if (i < colorKeys.length) {
            const colorName = colorKeys[i];
            const colorValue = colorsArray[colorName];
            element.setAttribute('data-bg-value', colorValue);
            element.setAttribute('data-bg-name', colorName);
            element.classList.add('bg-scroll-color');
        }
        
        containerDiv.appendChild(element);
    }
}

function inViewport(element) {
    // Get the elements position relative to the viewport
    var bb = element.getBoundingClientRect();
    
    // Check if the element is outside the viewport
    // Then invert the returned value because you want to know the opposite
    return !(bb.top > innerHeight || bb.bottom < 0);
}

function colorScroller(containerDiv) {
    // Get all sections with the bg-scroll-color class
    const sections = document.querySelectorAll('.bg-scroll-color');

    // Array of data-bg attribute values
    const colorValues = Array.from(sections).map(section => section.getAttribute('data-bg-value'));

    // Calculate the height of each section
    const sectionHeights = Array.from(sections).map(section => section.getBoundingClientRect().height);

    // Calculate the total height of all sections
    const totalHeight = sectionHeights.reduce((acc, height) => acc + height, 0);

    window.addEventListener('scroll', () => {
        const scrollY = window.scrollY;
        let cumulativeHeight = 0;
        let currentIndex = 0;

        if (inViewport(document.querySelector('#js-color-scroller'))) {
            // Determine which section corresponds to the current scroll position
            for (let i = 0; i < sectionHeights.length; i++) {
                cumulativeHeight += sectionHeights[i];

                if (scrollY < cumulativeHeight) {
                    currentIndex = i;
                    break;
                }
            }

            // Set the background color based on the data-bg attribute of the current section
            containerDiv.style.backgroundColor = colorValues[currentIndex];   
        }  
    });
}

window.onload = function () {
    getElementMarkers();
};
